// extracted by mini-css-extract-plugin
export default {"image-crop":"FlowCard_image-crop__sWGRV","card-header":"FlowCard_card-header__sWkOZ"};